import { IonInput, IonItem, useIonRouter } from '@ionic/react';
import React from 'react';
import { useForm } from 'react-hook-form';

import { useSyncPets } from '../../../hooks/Pet/usePetUtils';
import { useAlert } from '../../../hooks/UI/useAlert';
import { useEnter } from '../../../hooks/Utils/useEnter';
import { SyncPet } from '../../../types/Pet/types';
import { validations } from '../../../utils/validations';
import Alert from '../../UI/Alert';
import Button from '../../UI/Button';
import FormItem from '../../UI/FormItem';
import Spinner from '../../UI/Spinner';
import './SyncPets.scss';
import { SyncPetsProps } from './types';

const SyncPets: React.FC<SyncPetsProps> = ({ header }) => {
  const { push } = useIonRouter();
  const { ref, handleEnter } = useEnter();
  const { syncPets, isLoading } = useSyncPets();
  const { alertState, showAlert, hideAlert } = useAlert();

  const { handleSubmit, control, errors } = useForm<SyncPet>({
    defaultValues: { email: '' },
  });

  const onSubmit = async (values: SyncPet) => {
    try {
      await syncPets(values.email);

      showAlert({
        header: 'Éxito',
        message:
          'Se ha enviado un correo con las instrucciones para continuar el proceso.',
        buttons: [
          {
            text: 'Entendido',
            handler: () => push('/tabs/home'),
          },
        ],
      });
    } catch (error) {
      console.error('Error asociando mascotas:', error);
      showAlert({
        header: 'Error',
        message: 'No se pudo procesar el email. Intente nuevamente.',
        buttons: [{ text: 'Reintentar', role: 'cancel' }],
      });
    }
  };

  return (
    <div className="sync-pets">
      {header}
      <div className="ion-padding">
        <div className="sync-pets__description ion-margin-bottom">
          Ingresa el email usado al contratar para traer a la aplicación las{' '}
          <span>mascotas cuyo seguro haya sido contratado por otro medio</span>; luego
          recibirás un correo con las instrucciones para continuar el proceso.
        </div>

        <form onSubmit={handleSubmit(onSubmit)} onKeyUp={handleEnter}>
          <FormItem
            errors={errors}
            render={({ onChange }) => (
              <IonItem className="ion-no-padding">
                <IonInput
                  type="email"
                  placeholder="correo.electronico@fielpet.com.ar"
                  onIonChange={onChange}
                />
              </IonItem>
            )}
            control={control}
            name="email"
            rules={{
              required: {
                value: true,
                message: 'Por favor, ingresa email',
              },
              pattern: validations.email,
            }}
          />

          <Button ref={ref} type="submit" disabled={isLoading}>
            {!isLoading ? 'Enviar' : <Spinner color="light" />}
          </Button>

          <Alert
            isOpen={alertState.isOpen}
            header={alertState.header}
            message={alertState.message}
            buttons={alertState.buttons}
            onDidDismiss={hideAlert}
          />
        </form>
      </div>
    </div>
  );
};

export default SyncPets;
